module.exports = __webpack_public_path__ + "img/projection.f5fa9cd9.png";